import React from 'react';

import { Check, X } from 'lucide-react';

import { IOS_SWITCH_PROPS } from '../../../utils/hapticUtils';

interface CheckboxFieldProps {
  id: string;
  value: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  subtext?: string | React.ReactNode;
  /**
   * Buzz an iPhone when a finger flips this control. Off by default and opted into per control,
   * not switched on for every checkbox in the product: a member ticking a course played wants the
   * feedback, an admin working down a permissions form does not.
   *
   * It changes nothing anywhere else. The attribute it adds is Safari-only, and the styling below
   * already strips the native look, which was measured not to cost the haptic.
   */
  haptic?: boolean;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({
  id,
  value,
  onChange,
  disabled,
  subtext,
  haptic = false,
}) => (
  <>
    {subtext && <span className="mb-5">{subtext}</span>}
    <label className="relative flex cursor-pointer items-center gap-2 text-ink dark:text-white/80">
      <input
        id={id}
        type="checkbox"
        {...(haptic ? IOS_SWITCH_PROPS : {})}
        checked={value}
        onChange={onChange}
        className="relative w-16 h-8 transition-colors appearance-none cursor-pointer peer rounded-2xl bg-gray-300 dark:bg-white/15
              after:absolute after:left-0 after:top-0 after:h-8 after:w-8 after:rounded-full
              after:bg-white dark:after:bg-white/70 after:transition-all checked:bg-secondary
              dark:checked:bg-white/25  checked:after:left-8 checked:after:bg-primary
              dark:checked:after:bg-primary focus:outline-none disabled:cursor-not-allowed"
        disabled={disabled}
      />
      <div
        className="flex absolute left-8 top-1 h-6 w-6 items-center justify-center text-ink dark:text-white/80 opacity-100
              transition-opacity peer-checked:opacity-0"
      >
        <X className="h-5 w-5" />
      </div>
      <div
        className="flex absolute left-1 top-1 h-6 w-6 items-center justify-center text-secondary opacity-0
              transition-opacity peer-checked:opacity-100"
      >
        <Check className="h-5 w-5" />
      </div>
    </label>
  </>
);

export default CheckboxField;
